import React from 'react'
import NavBar from '~/components/Nav/Bar'

export const Nav = props => {
  return <NavBar pages={props.pages} {...props} />
}

export default Nav
